import { Component, Input } from '@angular/core';

@Component({
  selector: 'import-error',
  templateUrl: './import-error.component.html',
  styleUrls: ['./import-error.component.scss']
})

export class ImportErrorComponent {
  @Input()
  public errors: any[] = [];
  @Input()
  public field: string = '';
}



// WEBPACK FOOTER //
// /dist/src/app/import/import-error/import-error.component.ts